import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import { PageFunctionType } from '@shared/core/analytics/telemetry/types';

const category = 'registry';
const pagePrefix = 'admin';
const page = 'overview';

interface RegistryOverviewInteractionArgs {
  component: string;
  method: string;
  label?: string;
}

type PagesForTelemetry = {
  registry: 'registry';
  purchase: 'purchase';
  contribute: 'contribute';
  cancelConfirm: 'cancelConfirm';
  welcome: 'welcome';
};

const pageTracking: { [key in keyof PagesForTelemetry]: PageFunctionType } = {
  registry: () => ({
    category: 'registry',
    pagePrefix: 'guest',
    page: 'Registry',
    action: 'ViewRegistry'
  }),
  purchase: () => ({
    category: 'registry',
    pagePrefix: 'guest',
    page: 'Purchase',
    action: 'ViewPurchase'
  }),
  contribute: () => ({
    category: 'registry',
    pagePrefix: 'guest',
    page: 'Contribute',
    action: 'ViewContribute'
  }),
  cancelConfirm: () => ({
    category: 'registry',
    pagePrefix: 'guest',
    page: 'CancelConfirm',
    action: 'ViewCancelConfirm'
  }),
  welcome: () => ({
    category: 'wedding',
    pagePrefix: 'guest',
    page: 'Welcome',
    action: 'ViewGiftsClick'
  })
};

export const registryOverviewTelemetry = createTelemetryObject({
  actions: {
    registryOverviewInteraction: ({ component, method, label }: RegistryOverviewInteractionArgs) => ({
      action: 'RegistryOverviewInteraction',
      actionType: undefined,
      pagePrefix,
      page,
      category,
      extraInfo: {
        component,
        method,
        label
      }
    }),
    adminRegistryQuickLinkInteraction: ({ component, method, label }: RegistryOverviewInteractionArgs) => ({
      action: 'AdminRegistryQuickLinkInteraction',
      actionType: undefined,
      pagePrefix,
      page,
      category,
      extraInfo: {
        component,
        method,
        label
      }
    }),
    registryManageTabClicked: (label: string) => ({
      action: 'RegistryManageTab',
      actionType: 'click',
      pagePrefix,
      page,
      category,
      extraInfo: {
        label
      }
    }),
    registryQuickStartInteraction: ({ component, method, label }: RegistryOverviewInteractionArgs) => ({
      action: 'RegistryQuickStartInteraction',
      actionType: undefined,
      pagePrefix,
      page: 'quickstart',
      category,
      extraInfo: {
        component,
        method,
        label
      }
    })
  },
  pages: pageTracking
});

const { TelemetryProvider, useTelemetry } = createTelemetry(registryOverviewTelemetry, { eventId: '' });

export { TelemetryProvider, useTelemetry as useRegistryOverviewTelemetry };
